module.exports = __webpack_public_path__ + "img/courseQ.e1c42948.png";